import BrandsSection from "../../../components/sections/home/brands-section/BrandsSection";
import CategoriesSlider from "../../../components/sections/home/categories-slider/CategoriesSlider";
import DiscountedProducts from "../../../components/sections/home/discounted-products/DiscountedProducts";
import Features from "../../../components/sections/home/features/Features";
import HeroSection from "../../../components/sections/home/hero/HeroSection";
import Newsletter from "../../../components/sections/home/newsletter/Newsletter";
import ProductsSection from "../../../components/sections/home/products/ProductsSection";
import TrendingProducts from "../../../components/sections/home/trending-products/TrendingProducts";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <DiscountedProducts />
      <CategoriesSlider />
      <ProductsSection />
      <Features />
      <TrendingProducts />
      <BrandsSection />
      <Newsletter />
    </div>
  );
};

export default Home;
